import {useEffect} from 'react';
import {
    useNavigate,
    useSearchParams
} from "react-router-dom";

import {
    Button,
    Center,
    Group,
    Stack,
    Title
} from "@mantine/core";

import {Cache} from 'aws-amplify';

import {accountsSelector} from '../../accounts/selectors';
import {fetchAccounts} from "../../accounts/reducers/recordsSlice";
import {
    useAppDispatch,
    useAppSelector
} from "../../../hooks/useTypedReactRedux.ts";
import {RootState} from "../../../store";
import {WaitAndButtonComponent} from '../components/WaitAndButtonComponent';
import {useOAuth2Authorization} from '../hooks/useOAuth2Authorization';

export const AuthorizePage = () => {

    const navigate = useNavigate()
    const dispatch = useAppDispatch();

    const [params] = useSearchParams();

    const redirectUrl = params.get('redirect_uri')
    const responseType = params.get('response_type')
    const clientId = params.get('client_id')
    const identityProvider = params.get('identity_provider')
    const scope = params.get('scope')
    const state = params.get('state')

    Cache.setItem('authorization', {
        redirectUrl,
        responseType,
        clientId,
        identityProvider,
        scope,
        state
    })

    const accounts = useAppSelector((state: RootState) => accountsSelector(state));

    useEffect(() => {
        dispatch(fetchAccounts());
    }, []);

    useOAuth2Authorization(accounts, {redirectUrl, clientId, state});

    if (accounts.length === 0) {
        return (<Center>
            <Stack>
                <Title my={'xl'}>No accounts found. Please, sign in again!</Title>
                <Center my={'xl'}>
                    <Button onClick={() => navigate('/')}>Sign In</Button>
                </Center>
            </Stack>
        </Center>)
    }


    return (
        <Group mt={'lg'} justify={'center'}>
            <WaitAndButtonComponent/>
        </Group>
    )


}
